module.exports = __webpack_public_path__ + "img/160005.4cf16fbf.png";